function getRootState(aais) {
    return new Promise((resolve, reject) => {
        aais.forEach(aai => {
            aai.addresses.forEach(address => {
                if (
                    address.is_current &&
                    address.administrative_area_level_1 &&
                    address.administrative_area_level_1.trim()
                )
                    resolve(
                        address.administrative_area_level_1.trim().toLowerCase()
                    );
            });
        });

        resolve(null);
    });
}

export { getRootState };
